import React, { FC } from 'react'
import { Field } from 'redux-form'
import { Input, Label } from 'semantic-ui-react'
//@ts-ignore
import { ComponentContainer } from 'shared/StyledComponents'
import { AccSearchTitleComponentProps } from '../components.type'

const component: FC<AccSearchTitleComponentProps> = ({
  input,
  meta: { active, error, submitting, submitFailed },
  type,
}) => {
  return (
    <div>
      <ComponentContainer input>
        <Input
          fluid
          {...input}
          onChange={(_, { value }) => input.onChange(value)}
          onFocus={(e: React.FocusEvent<HTMLInputElement>) => {
            e.target.select()

            input.onFocus(e)
          }}
          type={type}
          loading={submitting}
          error={submitFailed}
          autoFocus
        />
      </ComponentContainer>

      {active && error && (
        <Label style={{ position: 'absolute', left: 62, zIndex: 1 }} basic color="red" pointing>
          {error}
        </Label>
      )}
    </div>
  )
}

const AccSearchTitle = () => <Field name="title" component={component} type="text" />

export default AccSearchTitle
